import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Product } from '@app/router/products/Product';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { defaultLayout } from '@app/router/utils';
import { topManagerPage } from '@pages/TopManagerPage';
import { Theme } from '@superbet-group/web.lib.ui-components';

export const topManagerRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.Free2Play.TopManager,
        name: RouteName.Free2Play.TopManager,
        isAccessible: Product.Free2Play.TopManager,
        components: {
            ...defaultLayout,
            ...topManagerPage,
        },
        meta: {
            layoutClass: 'f2p-game',
            forcedTheme: Theme.Dark,
        },
    },
];
